import React from "react";

const Background = ({ children }) => {
  return <div className=" dashboard-bg min-h-screen">{children}</div>;
};

export default Background;
